import React from 'react';
// import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';

const useStyles = makeStyles((theme) => ({
  modal: {
    zIndex: theme.zIndex.modal + ' !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    color: '#4d4f5c',
    maxHeight: '95%',
    overflowY: 'auto',
    outline: 'none',
  },
}));

/**
 * 기본 레이아웃 모달 불러오기
 */
const ModalBasic = ({
  children,
  open,
  onClose = (f) => f,
  width = 'auto',
  height = 'auto',
}) => {
  const classes = useStyles();

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            className={classes.paper}
            style={{ width: width, height: height }}
          >
            {children}
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default withRouter(ModalBasic);
